<template>
  <div v-if="definitionModule">
    <loader :loading="loading"/>
    <page-title :image="moduleLogo" :title="$t('configurations.label')">
      <div class="btnGroup" slot="header-right">
        <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !definitionModule.module.status }" class="btn btn--info btn--outline">
          Inativo
        </button>
        <button @click="changeStatus(true)" v-bind:class="{ 'is-active': definitionModule.module.status }" class="btn btn--info btn--outline">
          Ativo
        </button>
      </div>
    </page-title>
    <div v-if="refreshAlert()">
      <h5>Permissão Pendente</h5>
      <p>Por favor, entre em <a href="https://seller.magalu.com/">Painel Seller Integracommerce</a> e realize a permissão de acesso ao Placemarket para renovação de token. Para dúvidas, entre em contato com o Suporte Placemarket</p>
    </div>
    <form @submit.prevent="save" id="configuration">
      <panel v-if="useAuthentication" title="Autenticação">
        <loader :loading="authenticating" label="Autenticando..."/>
        <span slot="header-right" v-if="!authenticating" :class="authenticated ? 'badge badge--success' : 'badge badge--danger'">{{ authenticated ? 'Autenticado' : 'Não Autenticado'}}</span>
        <slot name="auth"/>
      </panel>
      <slot/>
      <panel v-if="(useAuthentication && data) || saveButton">
        <button :disabled="saving" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" type="submit">Salvar</button>
      </panel>
    </form>
  </div>
</template>

<script>
  import { merge } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'

  export default {
    inject: ['moduleDI'],
    data: () => ({
      saving: false,
      loading: false,
      authenticating: true,
      authenticated: false
    }),
    props: {
      saveButton: {
        type: Boolean,
        required: false,
        default: true
      },
      data: {
        type: Object,
        default: null
      },
      errors: {
        type: Array,
        required: true
      },
      useAuthentication: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    async mounted () {
      await this.fetch()

      await this.fetchModuleConfiguration({
        type: this.moduleDI.type,
        identifier: this.moduleDI.identifier
      })

      this.changeAuth()

      this.loading = false
    },
    methods: {
      ...mapActions('module', [
        'fetch',
        'fetchModuleConfiguration',
        'saveConfiguration',
        'active',
        'inactive',
        'checkAuth'
      ]),
      refreshAlert () {
        return this.moduleDI.identifier === 'integracommerce' && !this.authenticated
      },
      changeAuth () {
        if (this.useAuthentication) {
          this.authenticating = true

          this.authenticated = this.checkAuth({
            type: this.moduleDI.type,
            identifier: this.moduleDI.identifier
          })
            .then(result => { this.authenticated = result })
            .catch(() => { this.authenticated = false })
            .then(() => {
              this.authenticating = false
              this.$emit('authenticated', this.authenticated)
              if (!this.authenticated && this.moduleDI.identifier === 'integracommerce') {
                notifier.error('Acesse o link no topo da página para liberar acesso ao Placemarket.', 'Autenticação')
              }
            })
        }
      },
      validateSave () {
        if (this.moduleDI.identifier !== 'moovin' && this.moduleDI.identifier !== 'ecomece' && (this.data.order !== undefined) && (this.data.order.expediter.identifier === null || this.data.order.expediter.type === null)) {
          notifier.error('Selecione o módulo de expedição', 'Campos Obrigatórios')
          return false
        }

        if (this.moduleDI.identifier === 'amazon' && (this.data.serviceTerms.accepted === false)) {
          this.changeStatus(false)

          notifier.error('Aceite os Termos de Uso', 'Termos de Uso')
          return false
        }

        if (this.moduleDI.identifier === 'mercadoLivre' && (!this.data.product.shippingMode || !this.data.product.type)) {
          notifier.error('Verifique se os campos "Tipo Padrão" e "Tipo Envio" estão preenchidos.', 'Campos Obrigatórios')
          return false
        }

        return true
      },
      save () {
        this.saving = true

        if (!this.validateSave()) {
          this.saving = false
          return
        }

        this.saveConfiguration({
          type: this.moduleDI.type,
          identifier: this.moduleDI.identifier,
          configuration: this.data
        })
          .then(() => notifier.success('Configurações salvas com sucesso!', 'Salvo'))
          .catch(() => notifier.error('Falha ao salvar as configurações, tente novamente mais tarde.', 'Não salvo'))
          .then(() => {
            this.changeAuth()

            this.saving = false

            this.$emit('save')
          })
      },
      validateChangeStatus () {
        if (this.moduleDI.identifier === 'amazon' && (this.data.serviceTerms.accepted === false)) {
          notifier.error('Aceite os Termos de Uso para ativar o modulo', 'Termos de Uso')
          return false
        }

        return true
      },
      async changeStatus (status) {
        let promise = null

        if (status === true) {
          if (!this.validateChangeStatus()) {
            return
          }

          try {
            await this.save()
          } catch (error) {
            notifier.error('Falha ao salvar as configurações, não foi possível alterar o status.', 'Erro de Salvamento')
            return
          }
        }

        if (status) {
          promise = this.active({
            type: this.moduleDI.type,
            identifier: this.moduleDI.identifier
          })
        } else {
          promise = this.inactive({
            type: this.moduleDI.type,
            identifier: this.moduleDI.identifier
          })
        }

        promise
          .then(() => notifier.success('Status alterado com sucesso!', 'Salvo'))
          .catch(() => notifier.error('Falha ao alterar o status, tente novamente mais tarde.', 'Não alterado'))
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType(this.moduleDI.type, this.moduleDI.identifier)
      },
      moduleLogo () {
        if (this.definitionModule.type !== 'tool') {
          return this.definitionModule.logo
        }
      }
    },
    watch: {
      definitionModule () {
        merge(this.data, this.definitionModule.module.configs)
      }
    },
    components: {
      Panel,
      Loader,
      PageTitle
    }
  }
</script>

<style scoped lang="sass">
  .logo
    max-height: 30px
    margin-right: 20px

  .title
    margin-top: 16px
    margin-left: 20px
</style>



// WEBPACK FOOTER //
// Shared.vue?bd1b658e